// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__18LhG","inputWrap":"styles_inputWrap__1wxsZ","input":"styles_input__3EZ9k"};